<template>
    <div class="row">
        <div class="col-12 col-md-8 col-lg-9">
            <form>
                <div class="profileUpdateMsg"></div>

                <div class="form-group">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label>First name</label>
                                <input type="text" class="form-control" name="firstname" id="firstname"
                                    placeholder="First Name" v-model="firstname" 
                                    data-vv-as="first name" v-validate="'required'"
                                >
                                <span class="d-block text-danger">{{ errors.first('firstname') }}</span>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label>Last name</label>
                                <input type="text" class="form-control" name="lastname" id="lastname"
                                    placeholder="Last Name" v-model="lastname"
                                    v-validate="'required'" data-vv-as="last name"
                                >
                                <span class="d-block text-danger">{{ errors.first('lastname') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label for="">Email Address</label>
                            <input type="text" name="email" id="email" class="form-control" disabled
                                placeholder="Your email" v-model="email"
                            >
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <button class="btn btn-success px-5" @click.prevent="updateProfileData($event)">
                        Save
                    </button>
                </div>
            </form>
        </div>

        <div class="col-12 col-md-4 col-lg-3">
            <avatar></avatar>
        </div>    

    </div>
</template>

<script>
    import Avatar from './Avatar.vue'
    import axios from 'axios';
    export default {
        components: {Avatar},
        name: 'Profile',
        data() {
            return {
                firstname: '',
                lastname: '',
                email: ''
            }
        },
        methods: {
            fetchProfileData() {
                this.firstname = this.$store.state.userData.firstname;
                this.lastname = this.$store.state.userData.lastname;
                this.email = this.$store.state.userData.email;
            },

            //Update data
            updateProfileData(e) {
                $('.s-v-e').remove();
                let btn = e.currentTarget;

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        $(btn).addClass('is-loading is-loading-sm').attr('disabled', '');

                        let requestData = {
                            firstname: this.firstname,
                            lastname: this.lastname,
                            mask: this.$store.state.userData.adminid
                        };

                        let token = this.$store.state.userData.access_token;

                        let params = new URLSearchParams();
                        params.append('firstname', requestData.firstname);
                        params.append('lastname', requestData.lastname);
                        params.append('mask', requestData.mask);

                        axios.post(APIURL + 'admin/profile/update', params)
                        .then((response) => {
                            $(btn).removeClass('is-loading is-loading-sm').removeAttr('disabled', '');
                            let res = response.data;

                            if (res.status == 200) {
                                let user = {
                                    firstname: res.data.firstname,
                                    lastname: res.data.lastname,
                                    adminid: res.data.mask,
                                    email: res.data.email,
                                    profileImg: '',
                                    access_token: token
                                };

                                this.$store.commit('SET_USER_DATA', user);
                                window.localStorage.setItem('authUser', JSON.stringify(user));
                                this.$swal('Success', res.msg, 'success');
                            }
                            else {
                                if (res.status == 403) {
                                    $.each(res.errors, function (k, v) {
                                        $('#' + k).after(v);
                                    })
                                }
                                else {
                                    this.$swal('Error', res.msg, 'error');
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                    }
                })
                
            }
        },
        created() {
            this.fetchProfileData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/profile/Profile.vue